import Player from '@vimeo/player'
import type { TVimeoData } from '~/types/app.type'

export default defineNuxtPlugin({
  name: 'rudderstack',
  dependsOn: ['restClient'],
  async setup() {
    const { $restClient } = useNuxtApp()

    const getVideoData = async (
      vimeoId: string | number,
    ): Promise<TVimeoData> => {
      try {
        const data = await $restClient.getVimeoVideoData(vimeoId)

        return {
          title: data.name,
          duration: data.duration,
        }
      } catch (error) {
        logError(error)
      }
    }

    return {
      provide: {
        vimeo: {
          init(
            element: HTMLIFrameElement | HTMLElement | string,
            options?: Player.Options,
          ) {
            return new Player(element, options)
          },
          getVideoData,
        },
      },
    }
  },
})
